const CheckIcon: React.FC<React.SVGAttributes<{}>> = ({width = 24, height = 24, ...props}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke="currentColor" {...props}>
            <path d="M20 6L9 17L4 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default CheckIcon;
